// src/components/search/EventResultCard.tsx

import React from 'react';
import { Card, CardContent, Typography, Stack, Box } from '@mui/material';
import { Event as EventIcon, CalendarToday, LocationOn, Person } from '@mui/icons-material';
import { EventArticle } from '@/types/news.types';
import { formatDate, formatTime } from './utils/dateFormatters';

interface EventResultCardProps {
  event: EventArticle;
}

export const EventResultCard: React.FC<EventResultCardProps> = ({ event }) => (
  <Card
    sx={{
      mb: 2,
      cursor: 'pointer',
      '&:hover': { boxShadow: 3 },
      transition: 'box-shadow 0.2s'
    }}
  >
    <CardContent>
      <Stack direction="row" spacing={2} alignItems="flex-start">
        <EventIcon sx={{ color: 'secondary.main', mt: 0.5 }} />
        <Box flex={1}>
          <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
            {event.title}
          </Typography>
          <Stack spacing={1}>
            <Stack direction="row" spacing={1} alignItems="center">
              <CalendarToday sx={{ fontSize: 16, color: 'text.secondary' }} />
              <Typography variant="body2" color="text.secondary">
                {formatDate(event.date)} - {formatTime(event.date)}
              </Typography>
            </Stack>
            <Stack direction="row" spacing={1} alignItems="center">
              <LocationOn sx={{ fontSize: 16, color: 'text.secondary' }} />
              <Typography variant="body2" color="text.secondary">
                {event.place}
              </Typography>
            </Stack>
            <Stack direction="row" spacing={1} alignItems="center">
              <Person sx={{ fontSize: 16, color: 'text.secondary' }} />
              <Typography variant="body2" color="text.secondary">
                {event.manager}
              </Typography>
            </Stack>
          </Stack>
        </Box>
      </Stack>
    </CardContent>
  </Card>
);
